import { Box, Button, Checkbox, Drawer, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../../../utils/icons"
import { useStyles } from "./styles"
import { DrawerSettingsProps } from "./types"
import { channelSending } from "../../utils/constans/constans"
import { useEffect, useMemo, useState } from "react"
import { ChannelSend } from "../../utils/enums/tabs"
import { LoadingButton } from "@mui/lab"



export const DrawerSettings = (props: DrawerSettingsProps) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const channelOptions = useMemo(() => channelSending(t), [t]);
    const [checks, setChecks] = useState<Record<ChannelSend, boolean>>({
        [ChannelSend.EMAIL]: false/* props.openDrawer.user.notifications.email */,
        [ChannelSend.APP]: false/* props.openDrawer.user.notifications.app */,
      });

    useEffect(()=>{
        setChecks({
            [ChannelSend.EMAIL]: props.openDrawer.user.notifications.email,
            [ChannelSend.APP]: props.openDrawer.user.notifications.app,
        });
    },[props.openDrawer.user.notifications])

    const handleChannelChecks = (channel: ChannelSend) => {
        setChecks((prevChecks) => ({
          ...prevChecks,
          [channel]: !prevChecks[channel],
        }));
    };

    return (
        <Drawer sx={styles.drawer} anchor="right" open={props.openDrawer.setting}>
            <IconButton
                sx={styles.iconClose}
                onClick={() => {
                    props.closeDrawer()
                }}
            >
                {icons('simple-close')}
            </IconButton>

            <Box sx={styles.body}>
                <Typography sx={styles.drawerTitle}>{t('department.form.settings.notificationsTitle')}</Typography>

                {!!props.openDrawer?.user?.name && (
                    <Box>
                        <Typography sx={styles.drawerTitle}>{t('department.form.settings.user')}</Typography>
                        <Typography variant="title_grey_big">{props.openDrawer?.user?.name ?? ''}</Typography>
                    </Box>
                )}

                {!!props.openDrawer?.user?.totalUsers && (
                    <Typography variant="title_grey_big">
                            {t('reportFolio.notificationCenter.selectedUserWithCount',{ count: props.openDrawer?.user?.totalUsers }) }
                    </Typography>
                )}

                <Typography sx={styles.drawerTitle}>{t('reportFolio.notificationCenter.indicateTheChannelsForUserNotifications')}</Typography>

                <Typography sx={styles.drawerTitle} className="wSc">{t('reportFolio.notificationCenter.notifications')}</Typography>

                <Box>
                    {channelOptions.map(option => (
                        <Box key={option.id} sx={{display:'flex',alignItems:'center'}}>
                            <Checkbox
                                className='remove-m'
                                name="channel"
                                checked={checks[option.value as unknown as ChannelSend]}
                                onChange={() => {
                                    handleChannelChecks(option.value as unknown as ChannelSend)
                                }}
                                sx={styles.checkBox}
                            />
                            <Typography sx={styles.drawerTitle}>{option.label}</Typography>
                        </Box>
                    ))}
                </Box>
            </Box>

            <Box sx={styles.containerFooter}>
                <Typography variant="body1" sx={styles.cleanFilters} onClick={() => { props.closeDrawer() }}>
                        {t('general.cancel')}
                    </Typography>
                    
                <LoadingButton
                    onClick={() => {
                        props.loadData.onClick(props.openDrawer?.user?.id,checks[1],checks[2])
                        if(props.openDrawer.user.totalUsers){
                            props.setSelectedUsers([])
                        }
                        /* props.closeDrawer()
                        props.close()
                        props.setSelectedUsers([]) *///hacer esto si se guardo con exito
                    }}
                    disabled={!checks[1] && !checks[2]}
                    variant="contained"
                >
                    {t('reportFolio.notificationCenter.applyConfiguration')}
                </LoadingButton>
                
            </Box>
        </Drawer>
    )
}
